import React, { useEffect } from "react";
import {
    Box,
    Heading,
    Text,
    Avatar,
    GridItem,
    VStack,
    SimpleGrid,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ItemList = ({ teacherState, curPage, itemLimit, curItems, setCurItems }) => {
    const { t } = useTranslation();
    const history = useHistory();

    useEffect(() => {
        const offset = curPage * itemLimit;
        const getList = (curPage, itemLimit) => {
            setCurItems(teacherState.slice(offset, offset + itemLimit));
        };
        getList(curPage, itemLimit);
    }, [curPage, itemLimit, teacherState]);

    return (
        <SimpleGrid
            columns={{ base: 1, sm: 2, md: 2, lg: 4 }}
            spacingX={{ base: 5, lg: 10 }}
            w="full"
            minH="60vh"
        >
            {curItems?.map((row) => (
                <GridItem key={row?._id} w="100%" mt={5}>
                    <Box
                        p={4}
                        borderRadius="xl"
                        _hover={{ bg: 'gray.100' }}
                        cursor="pointer"
                       onClick={() => history.push(`/showprofile/${row._id}`)}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        textAlign="center"
                        transition="background 0.2s"
                    >
                        <Avatar
                            size="2xl"
                            src={row.avatar || '../images/avatar.png'}
                            alt={`${row.firstname} ${row.lastname}`}
                            mb={4}
                        />
                        <VStack spacing={1}>
                            <Heading fontSize="md">
                                {row.firstname} {row.lastname}
                            </Heading>
                            <Text fontSize="sm" color="gray.500" noOfLines={1}>
                                {row.email}
                            </Text>
                        </VStack>
                    </Box>
                </GridItem>
            ))}
        </SimpleGrid>
    );
};

export default ItemList;
